export class DocumentLogo {
	name = null;
	file = {};
}

export const agentOfficesFilterInitialValues = {
	officeName: "",
	primaryContact: "",
	phone: "",
	businessUnit: "",
	package: "",
};
